import { PenetratingBlowsEffect } from 'game/extended/heros/paladin/penetrating_blows/penetrating_blows_effect'

export default {
    events: {},
    effects: {
        PenetratingBlowsEffect

    },
    requirements: {}
}